/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SuppressTimeRegOnProjectWarningInput = {
    projectId: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type suppressTimeRegOnProjectWarningMutationVariables = {
    input: SuppressTimeRegOnProjectWarningInput;
};
export type suppressTimeRegOnProjectWarningMutationResponse = {
    readonly suppressTimeRegOnProjectWarning: {
        readonly clientMutationId: string | null;
    } | null;
};
export type suppressTimeRegOnProjectWarningMutation = {
    readonly response: suppressTimeRegOnProjectWarningMutationResponse;
    readonly variables: suppressTimeRegOnProjectWarningMutationVariables;
};



/*
mutation suppressTimeRegOnProjectWarningMutation(
  $input: SuppressTimeRegOnProjectWarningInput!
) {
  suppressTimeRegOnProjectWarning(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SuppressTimeRegOnProjectWarningInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SuppressTimeRegOnProjectWarningPayload",
    "kind": "LinkedField",
    "name": "suppressTimeRegOnProjectWarning",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "suppressTimeRegOnProjectWarningMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "suppressTimeRegOnProjectWarningMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "suppressTimeRegOnProjectWarningMutation",
    "operationKind": "mutation",
    "text": "mutation suppressTimeRegOnProjectWarningMutation(\n  $input: SuppressTimeRegOnProjectWarningInput!\n) {\n  suppressTimeRegOnProjectWarning(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '3810a21558a0a8e71000f2e69cd355c2';
export default node;
